/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

export enum UserRole {
  BASIC_USER = "BASIC",
  STANDARD_USER = "STANDARD",
  PRIVILEGED_USER = "PRIVILEGED",
  SUPER_ADMIN = "SUPER_ADMIN",
}
